module.exports = __webpack_public_path__ + "static/media/image-5.98ffcb60.jpg";